// import "core-js/stable"
// import "regenerator-runtime/runtime"

import React from "react";
import ReactDOM from "react-dom"
import CsrDialog from "./components/CsrDialog.jsx"
import P12Dialog from "./components/P12Dialog.jsx"

window.keys = {
  React: React, 
  ReactDOM: ReactDOM,
  CsrDialog: CsrDialog, 
  P12Dialog: P12Dialog, 
};

const certPem = `-----BEGIN CERTIFICATE-----
MIIDmjCCAYKgAwIBAgIUKVX5vfgcpe210n8+VltSIadPoKMwDQYJKoZIhvcNAQEL
BQAwADAeFw0yMTAzMTkxNDU3NTJaFw0yMjAzMTkxNDU3NTJaMA4xDDAKBgNVBAMT
A0ZyYTCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBALmTicl5ga+IkKUf
wNp63a8xr65yDNJvyUwJEAVuxmHt37JLJKicB2qpYyWFO8S6sU8oNepsfhvXoW8L
yTvCYwNONOoD1DGrBLx4mjpq6CxwlkavsWpYuSB2rf/b2w+4sWO4ze6laSgAatoQ
XMowvvcLTGj2zcUx+Eq6ShV/pGbk98Bj2Yg0RBzO220ucHNVGgAllpGL5YkAxM36
+r2L7LKullfwan7aY/yXlcZkWnxIVg3nznlbONh50e67f23iincmI6fz/ydkaaW4
YeiFt8YmOvi9bNCnCGzZ3sGdZB+2mruuSGriigguX3TSKNw+yjqzkGhWgTThzEQF
6t3/c2kCAwEAATANBgkqhkiG9w0BAQsFAAOCAgEAhHbpXYaGbRTS3cnJs3hb/uFQ
dNfxTfc3Je7dfot+LQeUe/vQDM+GrKjzjXN524w1/C+Mbs30GmmkOnq7G6GuyQDY
5POnpv3JAm9sEMQQv62GIxo5aOdshbYPdoXOKBVCiYtaH4nd+3fBjItrLMxY8Tzj
LK9k2GUPvRdug0gPoj22K9pYDs6WmIKDCPe9i0xMJPyRihL1YRoCYrWcBZSlKBj8
r38nDjTLxdGQJgLvWbdCZL2LYY6ND+hY2bNOv7nXPsCGT+xCfMtuBguO8wlFInRU
wM7KjoEKeJjUcPE7MDYGcO75Kz/UOiRok3QR79cvWxFfX62obVmLELn3GqqowtSX
hsAWPPF0Sxc4bgHcnEMTOC5TbUO7n3fw2W+ZPJ3NCHb0WArCVVWvcntsNhKuwQDX
YpM0swgIAmBZR/0TvHB4tAGE0FmVwRvqeRU/IjI0xYCHPoat4tVPVhowSyKoNtHU
EmCeUZT8CpbtTpSF6PuZ3snw294AELHrfTwWiI7XS19Tacy5e3yTklEHddo8qODa
9iOTVK8MYGVIYA5avSSLyIxn7YcWjZTNzoZGQ2pRMnjkZN21Aq4gntGWFL4hC/MQ
wzlzns57rj7ynLpJOSPGey/qrFHUNKBSqCuFEBnOLqZoIjJu1i6yloxUOeO9JVyK
SFD2diuADbMcqbUwTIA=
-----END CERTIFICATE-----`

const Main = () => {
  return (
    <main className="container">
      <P12Dialog certPem={certPem} />
    </main>
  )
}

const root_element = document.getElementById("app-root")
if (root_element) {
  ReactDOM.render(
    <Main />,
    root_element
  )
}
